

















import VueOptions from '@utils/VueOptions'
import EventSchedule from '@ui/EventSchedule/EventSchedule'
import Modal from '@/components/Modal'
import RequestButton from '@/components/RequestButton'

settings =
  name: "EventScheduleShowPage"
  components: { EventSchedule, Modal, RequestButton }

  resources:
    newOffer:
      resourceName: 'offer'
      slug: 'event_schedules/:scheduleId/offers/new'

  vue:
    data: ->
      createOfferModal:
        show: false

    computed:
      scheduleId: -> @$route.params.eventScheduleId

    methods:
      onSave: (item) -> @$router.push({ name: 'OfferEditPage', params: { offerId: item.id } })
      hiCreateOffer: -> @saveItem('prime.newOffer')
      openCreateOfferModal: -> @createOfferModal.show = true
      closeCreateOfferModal: -> @createOfferModal.show = false

export default VueOptions.vue settings
